import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const VendorScheduleUpdates = () => {
  const [services, setServices] = useState([]);
  const [selectedDetails, setSelectedDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const vendor_id = user.id;

  useEffect(() => {
    Promise.all([
      fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/services_with_details`).then(res => res.json()),
      fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/vendor_selection?vendor_id=${vendor_id}`).then(res => res.json())
    ])
      .then(([servicesData, vendorSelectionData]) => {
        // Only display services where is_active = 1
        const activeServices = (servicesData.services || []).filter(service => service.service_active === 1);
        setServices(activeServices);
        setSelectedDetails(vendorSelectionData.details || []);
        setLoading(false);
      })
      .catch(() => {
        setServices([]);
        setSelectedDetails([]);
        setLoading(false);
      });
  }, [vendor_id]);

  const handleAdd = async (detailId) => {
    try {
  await fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/vendor_selection/update`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ vendor_id, add: detailId }),
      });
      setSelectedDetails(prev => [...prev, detailId]);
      alert('Service detail added!');
    } catch {
      alert('Error adding service detail.');
    }
  };

  const handleUpdateNavigate = (detailId) => {
    navigate(`/vendorselection/${detailId}`);
  };

  if (loading) return (
    <div style={styles.container}>
      <div style={styles.loader}>
        <span className="fas fa-spinner fa-spin" style={{ fontSize: '2rem', color: '#8d6e36' }}></span>
        <div style={{ marginTop: '12px', color: '#8d6e36', fontWeight: 'bold' }}>Loading...</div>
      </div>
    </div>
  );

  return (
    <div style={styles.container}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '18px' }}>
        <button
          style={styles.backBtn}
          onClick={() => navigate(-1)}
        >
          &#8592; Back
        </button>
        <h2 style={{ ...styles.title, flex: 1 }}>
          <span role="img" aria-label="calendar" style={{ marginRight: 10 }}>🗓️</span>
          Update Your Service Details
        </h2>
      </div>
      <div style={styles.cardGrid}>
        {services.map(service => (
          <div key={service.id} style={styles.card}>
            <div style={styles.cardHeader}>
              <span style={styles.cardIcon}><i className="fas fa-briefcase"></i></span>
              <h3 style={styles.cardTitle}>{service.name}</h3>
            </div>
            <div style={styles.detailsList}>
              {service.details && service.details.length > 0 ? (
                service.details.map(detail => {
                  const isSelected = selectedDetails.includes(detail.id);
                  return (
                    <div key={detail.id} style={styles.detailRow}>
                      <span style={styles.detailName}>{detail.name}</span>
                      {isSelected ? (
                        <button
                          style={styles.updateBtn}
                          onClick={() => handleUpdateNavigate(detail.id)}
                        >
                          <i className="fas fa-edit" style={{ marginRight: 6 }}></i>
                          Update
                        </button>
                      ) : (
                        <button
                          style={styles.addBtn}
                          onClick={() => handleUpdateNavigate(detail.id)}
                        >
                          <i className="fas fa-plus" style={{ marginRight: 6 }}></i>
                          Add
                        </button>
                      )}
                    </div>
                  );
                })
              ) : (
                <div style={styles.empty}>No details available.</div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '1200px',
    margin: '40px auto',
    padding: '32px',
    background: '#fff',
    borderRadius: '16px',
    boxShadow: '0 4px 24px rgba(141,110,54,0.10)',
  },
  loader: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '60px 0',
  },
  title: {
    marginBottom: '32px',
    color: '#8d6e36',
    fontSize: '2rem',
    textAlign: 'center',
    fontWeight: 'bold',
    letterSpacing: '1px',
    background: 'linear-gradient(90deg, #fffde4 0%, #ffe0b2 100%)',
    borderRadius: '12px',
    padding: '18px 0',
    boxShadow: '0 2px 12px rgba(255,152,0,0.10)',
    fontFamily: 'cursive, sans-serif',
  },
  cardGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))',
    gap: '32px',
    marginTop: '18px',
  },
  card: {
    background: '#f5f6fa',
    borderRadius: '14px',
    boxShadow: '0 2px 12px rgba(64,120,192,0.10)',
    padding: '28px 18px',
    textAlign: 'left',
    minHeight: '220px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '18px',
  },
  cardIcon: {
    background: '#8d6e36',
    color: '#fff',
    borderRadius: '50%',
    width: '38px',
    height: '38px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.3rem',
    marginRight: '12px',
  },
  cardTitle: {
    fontSize: '1.18rem',
    fontWeight: 'bold',
    color: '#8d6e36',
    margin: 0,
  },
  detailsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  detailRow: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '6px',
    background: '#fff',
    borderRadius: '8px',
    padding: '10px 14px',
    boxShadow: '0 1px 4px rgba(64,120,192,0.07)',
    fontSize: '1.08rem',
    minHeight: '48px',
  },
  detailName: {
    fontWeight: 'bold',
    color: '#4078c0',
    marginRight: '8px',
    minWidth: '120px',
  },
  detailDesc: {
    color: '#555',
    marginLeft: '8px',
    fontStyle: 'italic',
    flex: 1,
  },
  updateBtn: {
    background: '#8d6e36',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    padding: '8px 20px',
    fontWeight: 'bold',
    fontSize: '1rem',
    cursor: 'pointer',
    marginLeft: 'auto',
    boxShadow: '0 1px 4px rgba(64,120,192,0.07)',
    transition: 'background 0.2s',
    display: 'flex',
    alignItems: 'center',
    height: '38px',
  },
  addBtn: {
    background: '#4078c0',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    padding: '8px 20px',
    fontWeight: 'bold',
    fontSize: '1rem',
    cursor: 'pointer',
    marginLeft: 'auto',
    boxShadow: '0 1px 4px rgba(64,120,192,0.07)',
    transition: 'background 0.2s',
    display: 'flex',
    alignItems: 'center',
    height: '38px',
  },
  empty: {
    color: '#888',
    fontSize: '1rem',
    marginTop: '12px',
    textAlign: 'center',
  },
  backBtn: {
    background: '#4078c0',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    padding: '10px 22px',
    fontWeight: 'bold',
    fontSize: '1rem',
    cursor: 'pointer',
    boxShadow: '0 1px 4px rgba(64,120,192,0.07)',
    marginRight: '18px',
  },
};

export default VendorScheduleUpdates;